var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mb-5"},[_c('button',{staticClass:"btn btn-lg btn-danger",on:{"click":_vm.confirm}},[_vm._v(" Start from the beginning ")])])}
var staticRenderFns = []

export { render, staticRenderFns }